export default __webpack_public_path__ + "static/emotions-news-9590d8a8620503043f9c1222a855ed57.jpeg";